import "core-js/modules/es.number.constructor.js";
export default {
  name: "downloading",
  props: {
    percentage: {
      type: Number
    }
  }
};